export default class history{
    history = [];
    current = -1;
    
    add(data){
        // console.log("lastkey : "+this.lastKey(),"current",this.current)
        // // if(this.current !== this.lastKey()){
        // //     console.log("delete key",(this.lastKey() - this.current))
        // //     this.history.splice(this.current,(this.lastKey() - this.current));
        // // }
    
        this.history = this.history.filter((v,key) => key <= this.current);
        
        this.history.push(JSON.stringify(data));
        this.current = this.lastKey();
    }
    
    clear() {
        this.current = -1;
        this.history = [];
    }
    
    lastKey(){
        return this.history.length - 1;
    }
    
    undo(){
        this.current -- ;
        if(this.current <= 0){
            this.current = 0;
        }
        // console.log("undo","lastkey : "+this.lastKey(),"current",this.current)
        return JSON.parse(this.history[this.current]);
    }
    redo(){
        this.current ++ ;
        
        if(this.current > this.lastKey()){
            this.current = this.lastKey();
        }
        // console.log("redo","lastkey : "+this.lastKey(),"current",this.current)
        return JSON.parse(this.history[this.current]);
    }
    
    first(){
        this.current = 0;
        let datas = JSON.parse(this.history[this.current]);
        this.current = 1;
        return datas
    }
    
    restore(data){
        this.history = data.history;
        this.current = data.current;
    }
    
    length(){
        return this.history.length;
    }
}